
const state = {
    dataFilter: null,
    isDataFilter: false
};

const mutations = {
    SET_DATA_FILTER: (state, info) => {
        state.dataFilter = info;
    },
    SET_IS_DATA_FILTER: (state, info) => {
        state.isDataFilter = info;
    },
    SPLICE_DATA_FILTER: (state, info) => {
        state.dataFilter.splice(info.index, 1);
    },
};

const actions = {
    setDataFilter({ commit }, info) {
        commit("SET_DATA_FILTER", info);
    },
    setIsDataFilter({ commit }, info) {
        commit("SET_IS_DATA_FILTER", info);
    },
    spliceDataFilter({ commit }, info) {
        console.log("update info", info);
        commit("SPLICE_DATA_FILTER", info);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/data_filter.js